import React from "react";
import { setCookie } from "../../../../helpers/common";
import history from "../../../../history";
import { useCommonContext } from "../../../context/common-context";

// todo update shrinkable to false
const DefaultCard = ({ category, shrinkable = true, showRed = false }) => {
  const { isGuest } = useCommonContext();

  const handleClick = React.useCallback(
    (href) => {
      if (category.link && category.link.defaultUrl) {
        if (isGuest) {
          setCookie(
            "ECommRedirectURL",
            encodeURIComponent(
              `${window.location.origin}${category.link.defaultUrl}`
            )
          );
        }
      }
      if (href) {
        window.location.href = href;
      }
    },
    [isGuest, category]
  );

  const activeTile = () => {
    return window.location.pathname === category.link.href ? "active" : "";
  };

  category.title =
    category.title.charAt(0).toUpperCase() + category.title.slice(1);

  return (
    <li className={"col-6 col-md-3 my-3 list-group d-block " + activeTile()}>
      <a
        onClick={() => handleClick(category.link.href)}
        href="javascript:void(0)"
      >
        <div className="card py-md-3 d-flex h-100 border">
          <div className="w-100 text-center border-0">
            <img className="p-2" src={category.image} alt={category.title + ' Icon Image'} />
          </div>
          <div className="card-body p-0 p-md-1 text-center">
            <h3 className={'font-weight-600 font-size-16 mt-0 mb-1' + (showRed ? "cancel-title-text" : "")}>
              {category.title}
            </h3>
            <p
              role="description"
              className={`font-weight-normal px-2 mb-0 font-size-14 ${
                shrinkable ? "middleEllipsis" : ""
              }`}
            >
              {category.desc}
            </p>
          </div>
          <a role="link" className="bg-transparent view-all-link border-0 card-footer font-weight-600 homepage-nav pb-md-0 px-1 text-center" href="javascript:void(0)" aria-label={category.link.label + ' of ' + category.title}>
            {category.link.label}
          </a>
        </div>
      </a>
    </li>
  );
};

export default DefaultCard;
